import React, { useState } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import Avatar from '@material-ui/core/Avatar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import BasketIcon from '../../icons/BasketIcon';
import ProdTagChipArrayTop from './ProdTagChipArrayTop';
import ProdTagChipArrayBottom from './ProdTagChipArrayBottom';
import Grid from "@material-ui/core/Grid";
import ObligatoryIcon from "../../icons/ObligatoryIcon";
import RecommendedIcon from "../../icons/RecommendedIcon";
import Tooltip from '@material-ui/core/Tooltip';
import translate from '../../other/translate.json';
import FavoriteButton from '../Favorites/FavoriteButton';
import icons_group from '../../other/icons_group.json';

export default function ProdLineCard(props) {
	const classes = useStyles();
	let { cart } = props
	const [prodBasket, _prodBasket] = useState(JSON.parse(localStorage.getItem('cartProd')) || []);
	let lang = localStorage.getItem('language') || 'Ru';

	const renderFavoritesIcon = (row, isCart, productFavorite) => {
		let productInFavorite = productFavorite && productFavorite.includes(row.ID);
		let title = productInFavorite ? translate.Words[`RemoveFromFavorite${lang}`] : translate.Words[`AddToFavorite${lang}`];
		let fill = productInFavorite ? '#FFFFFF' : '#BCBBD0';
		let onClick = /*isBasket ?*/ () => { props.saveCollection(row.ID, 'product', 'favorite', [].concat(row.AppsIDsNeeded.split(',').map(el => +el.trim()), row.AppsIDsRecommended.split(',').map(el => +el.trim()))); if (isCart && !!props.updateArr) { props.updateArr('favorite', row); } };
		let backgroundColor = productInFavorite ? '#EB505E' : undefined;


		return (
			<FavoriteButton fill={fill} title={title} onClick={onClick} backgroundColor={backgroundColor} />
		)
	}

	return (
		<Card className={classes.rootWide}>
			<Grid container xs={12} className={classes.cntrCardHeader}>
				<ProdTagChipArrayTop data={props.data} header={props.data[`DirectionTitle`]} position='top' />
			</Grid>

			<Grid container alignItems="flex-start" xs={12} className={classes.cntrCardBody}>
				<Grid container xs={4} alignItems="flex-start" className={classes.cntrCardBodyBlock}>
					<StyledCardHeader
						className={classes.header}
						avatar={
							<Avatar aria-label="recipe" className={classes.avatar}
								style={{ backgroundColor: props.data.Color && props.data.Color.length > 5 ? `#${props.data.Color}` : '#74D972' }}
								src={icons_group[`${props.data.Icon_GroupID}`]}
							>
							</Avatar>
						}
						title={
							<React.Fragment>
								{/* <Typography style={{ fontSize: '12px', lineHeight: '14px', fontWeight: '500', marginBottom: 8 }}>
									{props.data[`GroupTitle`]}
								</Typography> */}

								<a href={`/products/cftbank/prodlist?group=${props.data['Icon_GroupID']}`} className={classes.LinkType01}>
									{props.data[`GroupTitle`]}
								</a>
							</React.Fragment>
						}
						subheader={
							// <Typography className={classes.subheader}>
							// 	{props.data[`SubGroupTitle`]}
							// </Typography>

							<a href={`/products/cftbank/prodlist?group=&subgroup=${props.data['SubGroupTitle']}`} className={classes.LinkType02}>
								{props.data[`SubGroupTitle`]}
							</a>
						}
					/>
				</Grid>

				<Grid container xs={8}>
					<CardContent className={classes.content}>
						<Grid container xs={12}>
							<Grid container xs={6} direction="column" justify="flex-start" alignItems="flex-start" style={{ paddingRight: 25 }}>
								<a href={`/products/card/${props.data.ID}`} style={{ textDecoration: 'none', maxWidth: '100%' }} rel="noopener noreferrer" target="_blank">
									<Typography variant="body2" color="textSecondary" component="p" className={classes.contentBody}>
										{props.data[`Title`]}
									</Typography>
								</a>

								<a href={`/products/card/${props.data.ID}`} style={{ textDecoration: 'none', maxWidth: '100%' }} rel="noopener noreferrer" target="_blank">
									<Typography variant="body2" color="textSecondary" component="p" className={classes.contentSubbody}>
										{props.data[`BriefDescription`]}
									</Typography>
								</a>
							</Grid>

							<Grid xs={6} container direction="row" justify="flex-start" alignItems="flex-start" style={{ margin: 0, padding: '0 25px' }}>
								<Grid item container direction="row">
									<Grid item style={{ padding: 0, marginBottom: 6 }}>
										<Typography className={classes.Body2medium}>{translate.Words[`Applications_${lang}`]}</Typography>
									</Grid>

									<Grid item container direction="row" className={classes.priceContainer}>
										{
											props.data.AppsIDsNeededCount > 0
												?
												<React.Fragment>
													<Grid item style={{ width: 24 }}>
														<ObligatoryIcon fill={'#EB505E'} />
													</Grid>

													<Grid item style={{ width: 199 }}>
														<Typography className={classes.Caption1}>{translate.Words[`LicensingRequired${lang}`]}</Typography>
													</Grid>

													<Grid item style={{ marginLeft: 12 }}>
														<Typography className={classes.Caption1} style={{ color: '#24262A' }}> {props.data.AppsIDsNeededCount} </Typography>
													</Grid>
												</React.Fragment>
												:
												null
										}
									</Grid>

									<Grid item container direction="row" className={classes.priceContainer}>
										{
											props.data.AppsCodeRecommendedCount > 0
												?
												<React.Fragment>
													<Grid item style={{ width: 24 }}>
														<RecommendedIcon fill={'#FE9D67'} />
													</Grid>

													<Grid item style={{ width: 199 }}>
														<Typography className={classes.Caption1}>{translate.Words[`RecommendedForLicensing${lang}`]} <br /> {props.data.CommentIFRS === '1' ? `${translate.Words[`InRespectOfIFRSReporting${lang}`]}` : ''}</Typography>
													</Grid>

													<Grid item style={{ marginLeft: 12 }}>
														<Typography className={classes.Caption1} style={{ color: '#24262A' }}> {props.data.AppsCodeRecommendedCount} </Typography>
													</Grid>
												</React.Fragment>
												:
												null
										}
									</Grid>
								</Grid>
							</Grid>
						</Grid>
					</CardContent>
				</Grid>
			</Grid>

			<Grid container xs={12} className={classes.cntrCardFooter}>
				{cart === true
					?
					<CardActions disableSpacing className={classes.actions}>
						<Grid xs={12} container
							direction="row"
							justify="space-between"
							alignItems="center"
						>
							<Grid item style={{ marginLeft: -8 }}>
								<ProdTagChipArrayBottom position='middle' tags={props.data[`Tags`]} />
							</Grid>

							<Grid item container direction="row" justify="flex-end" alignItems="center">
								{/* ВТОРОЙ ЭТАП <Grid item>
								<Typography className={classes.Caption1} style={{ color: '#81D39D', marginRight: 16 }}>Лицензировано</Typography>
							</Grid> */}

								<Grid item>
									{/* ВТОРОЙ ЭТАП <IconButton aria-label="share" className={classes.icon}>
									<FavoritesIcon fill={'#BCBBD0'} />
								</IconButton> */}
									{renderFavoritesIcon(props.data, cart, props.userCollection.productFavorite)}
									<CustomTooltip placement="top" title={prodBasket && prodBasket.includes(props.data.ID) ? translate.Words[`RemoveFromBasket${lang}`] : translate.Words[`AddTobasket${lang}`]}>
										<IconButton color={'primary'} aria-label="share" className={classes.icon} onClick={() => { const row = props.data; props.saveCollection(row.ID, 'product', 'cart', [].concat(row.AppsIDsNeeded.split(',').map(el => +el.trim()), row.AppsIDsRecommended.split(',').map(el => +el.trim()))); if (cart && !!props.updateArr) { props.updateArr('cart', row); } }} style={{ backgroundColor: prodBasket && prodBasket.includes(props.data.ID) ? '#EB505E' : '' }}>
											{/* {
												window.location.pathname.slice(1, 5) === 'cart'
													?
													<ClearIcon fill={prodBasket && prodBasket.includes(props.data.ID) ? '#FFFFFF' : '#BCBBD0'} />
													:
													<BasketIcon fill={prodBasket && prodBasket.includes(props.data.ID) ? '#FFFFFF' : '#BCBBD0'} />
											} */}
											<BasketIcon fill={prodBasket && prodBasket.includes(props.data.ID) ? '#FFFFFF' : '#BCBBD0'} />
										</IconButton>
									</CustomTooltip>
								</Grid>
							</Grid>
						</Grid>
					</CardActions>
					:
					<CardActions disableSpacing className={classes.actions}>
						<Grid xs={12} container
							direction="row"
							justify="space-between"
							alignItems="center"
						>
							<Grid item style={{ marginLeft: -8 }}>
								<ProdTagChipArrayBottom position='middle' tags={props.data[`Tags`]} />
							</Grid>

							<Grid item container direction="row" justify="flex-end" alignItems="center">
								{/* ВТОРОЙ ЭТАП <Grid item>
								<Typography className={classes.Caption1} style={{ color: '#81D39D', marginRight: 16 }}>Лицензировано</Typography>
							</Grid> */}

								<Grid item>
									{/* ВТОРОЙ ЭТАП <IconButton aria-label="share" className={classes.icon}>
									<FavoritesIcon fill={'#BCBBD0'} />
								</IconButton> */}
									{renderFavoritesIcon(props.data, cart, props.userCollection.productFavorite)}
									<CustomTooltip placement="top" title={prodBasket && prodBasket.includes(props.data.ID) ? translate.Words[`RemoveFromBasket${lang}`] : translate.Words[`AddTobasket${lang}`]}>
										<IconButton color={'primary'} aria-label="share" className={classes.icon} onClick={() => { let row = props.data; props.saveCollection(row.ID, 'product', 'cart', [].concat(row.AppsIDsNeeded.split(',').map(el => +el.trim()), row.AppsIDsRecommended.split(',').map(el => +el.trim()))); if (!!props.updateArr) { props.updateArr('cart', row, 'product') }; }} style={{ backgroundColor: prodBasket && prodBasket.includes(props.data.ID) ? '#EB505E' : '' }}>
											<BasketIcon fill={prodBasket && prodBasket.includes(props.data.ID) ? '#FFFFFF' : '#BCBBD0'} />
										</IconButton>
									</CustomTooltip>
								</Grid>
							</Grid>
						</Grid>
					</CardActions>}
			</Grid>
		</Card >
	);
}



const CustomTooltip = withStyles((theme) => ({
	tooltip: {
		backgroundColor: 'rgba(60, 60, 86, 0.8)',
		color: '#FFFFFF',
		boxShadow: 'none',
		padding: 12,
		borderRadius: 8,
		fontWeight: 'normal',
		fontSize: '12px',
		lineHeight: '14px',
	},
}))(Tooltip);

const useStyles = makeStyles((theme) => ({
	rootWide: {
		minHeight: 218,
		marginBottom: 16,
		boxShadow: '4px 4px 10px rgba(164, 163, 186, 0.2)',
		borderRadius: theme.spacing(2),
		paddingTop: 10,
		// paddingRight: 0,
		// paddingBottom: 24,
		// paddingLeft: 0,
		padding: theme.spacing(3),
		'&:hover': {
			boxShadow: '4px 4px 20px rgba(164, 163, 186, 0.7)',
		}
	},

	avatar: {
		// backgroundColor: props.iconColor,
		height: 62,
		width: 62,
		borderRadius: 24,
		padding: 15,
		marginRight: 10
	},

	icon: {
		marginLeft: 8,
		backgroundColor: '#F6F6FB',
		width: 48,
		height: 48,
		'&:hover': {
			backgroundColor: '#F6F6FB',
		},
		'&:first-child': {
			marginLeft: 'auto',
		}
	},

	content: {
		// height: 289,
		// overflow: 'hidden',
		padding: 0,
		width: '100%',
		'&:last-child': {
			paddingBottom: 12
		}
		// marginTop: 16
	},

	contentBody: {
		fontSize: '14px',
		fontWeight: '500',
		lineHeight: '18px',
		color: '#000'
	},

	contentSubbody: {
		marginTop: theme.spacing(1),
		fontSize: '13px',
		fontWeight: '400',
		lineHeight: '16px',
		color: '#8987A2'
	},

	header: {
		padding: 0,
		title: {
			fontSize: 22
		}
	},

	subheader: {
		fontSize: '12px',
		lineHeight: '14px',
		fontWeight: 400,
		color: '#8987A2'
	},

	actions: {
		padding: '0',
		paddingTop: '7',
		width: '100%',
		// position: 'absolute',
		// bottom: 16,
		// right: 24
	},

	pricePrimary: {
		fontSize: '14px',
		fontWeight: 500,
		lineHeight: '18px',
		color: '#000'
	},

	priceSecondary: {
		fontSize: '14px',
		fontWeight: 500,
		lineHeight: '18px',
		color: '#8987A2'
	},

	cntrCardHeader: {
		// padding: '0 24px 0 24px',
		marginBottom: 8,
	},

	cntrCardBody: {},

	cntrCardBodyBlock: {
		// padding: '0 24px'
	},

	cntrCardFooter: {
		// padding: '0 24px 0 24px'
	},

	Caption1: {
		fontFamily: 'Cera CY',
		fontStyle: 'normal',
		fontWeight: 'normal',
		fontSize: '13px',
		lineHeight: '16px',
		color: '#8987A2'
	},

	Body2medium: {
		fontFamily: 'Cera CY',
		fontStyle: 'normal',
		fontWeight: '500',
		fontSize: '14px',
		lineHeight: '18px',
		color: '#000000'
	},

	priceContainer: {
		padding: '4px 1px'
	},

	LinkType01: {
		fontSize: '12px',
		lineHeight: '14px',
		fontWeight: '500',
		color: "#000000",
		textDecoration: "none",

		'&:hover': {
			textDecoration: 'none',
			borderBottom: '1px solid #000000',
		}
	},

	LinkType02: {
		fontSize: '12px',
		lineHeight: '14px',
		fontWeight: 400,
		color: '#8987A2',
		textDecoration: "none",

		'&:hover': {
			textDecoration: 'none',
			borderBottom: '1px solid #8987A2',
		}
	},
}));

const StyledCardHeader = withStyles({
	root: {
		alignItems: 'flex-start',
	},
})(CardHeader);

